import "/opt/buildhome/repo/sentry.client.config.js";
import { init } from 'astro/virtual-modules/prefetch.js';init()